import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { BLOG_POSTS } from "../data/blog";
import { FadeUp } from "../components/Motion";

const Blog = () => {
  return (
    <>
      <PageHeader
        tag="Field notes — The Nexa blog"
        title={
          <>
            Thinking with
            <br />
            <span className="text-nexa-red">teeth in it.</span>
          </>
        }
        sub="Dispatches from the den on brand building, social media, performance marketing, content and craft. The same aggression we bring to the work, in long form."
      />

      <section className="mx-auto max-w-[1600px] px-5 py-24 md:px-10" data-testid="blog-list">
        <div className="border-t border-white/10">
          {BLOG_POSTS.map((p, i) => (
            <FadeUp key={p.slug} delay={i * 0.05}>
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group grid gap-4 border-b border-white/10 py-10 transition-colors duration-300 hover:bg-nexa-surface md:grid-cols-12 md:items-baseline md:px-4"
              >
                <span className="font-mono text-sm text-nexa-red md:col-span-1">{String(i + 1).padStart(2, "0")}</span>
                <div className="md:col-span-7">
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-nexa-bone/50">
                    {p.category} · {new Date(p.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })} · {p.readTime}
                  </p>
                  <h2 className="mt-3 font-display text-3xl uppercase leading-tight tracking-tight text-nexa-bone transition-colors duration-300 group-hover:text-nexa-red md:text-4xl">
                    {p.title}
                  </h2>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-nexa-bone/55">{p.excerpt}</p>
                </div>
                <span className="hidden items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-nexa-bone/40 transition-colors duration-300 group-hover:text-nexa-red md:col-span-4 md:flex md:justify-end">
                  Read the note <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </FadeUp>
          ))}
        </div>
      </section>
    </>
  );
};

export default Blog;
